const iconsList = [
    "world",
    "A1-Mind",
    "approved",
    "computer",
    "car-bike",
    "insurance2",
    "learning",
    "community",
    "theater",
    "A2-Body-Yoga",
    "meditation",
    "A2-Body",
    "A3-We",
    "delete",
    "work1",
    "recycle",
    "hammock1",
    "hammock-and-man",
    "hammock-relaxing",
    "refresh-button",
    "outdoor-activity",
    "tent",
    "camping-tent",
    "start-up",
    "diet",
    "diet2",
    "cancel",
    "cancel_1",
    "close_1",
    "dr",
    "friends-talking",
    "adventurer",
    "hiking",
    "new-idea",
    "task",
    "task2",
    "store-new-badges",
    "new-mail",
    "new",
    "toolbox",
    "carpenter",
    "karaoke",
    "confetti",
    "fireworks",
    "men-shaking-hands",
    "enterprise",
    "atomic",
    "college-graduation",
    "A4-Context",
    "A5-Ready",
    "accounting",
    "add-lucket-icon",
    "add",
    "airplane",
    "analytics",
    "close",
    "collaboration",
    "dance",
    "diploma",
    "down-arrow",
    "drama",
    "edit",
    "exit2parent",
    "fast-food",
    "focus-icon",
    "forester-house",
    "guitar (1)",
    "guitar",
    "high-five",
    "insurance",
    "karate-master",
    "legal-paper",
    "line",
    "lineThick",
    "minus",
    "money",
    "mortarboard",
    "picture",
    "profile-user-with-earth-symbol",
    "reading",
    "remove",
    "scales-of-justice",
    "settings",
    "shovel",
    "success",
    "thought",
    "tourist",
    "up-arrow",
    "warrior",
    "weather-man"
];


export default iconsList;